import axios from 'axios';

const addNewSubProductApi = async (token, values, edit = false) => {
  try {
    let url;
    if (!edit) url = '/Product/createSub';
    else url = '/Product/createSub';

    const res = await axios.post(url, values, {
      headers: {
        lang: 'ar',
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + token
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default addNewSubProductApi;
